<template>
  <section class="py-10 bg-white">
    <div class="container mx-auto px-4">
      <div class="text-center mb-12">
        <div
          class="text-title font-bold text-[#333333] leading-tight mb-6 uppercase"
        >
          Factory Tour
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
        <div
          v-for="(video, index) in videos"
          :key="index"
          class="video-item group"
        >
          <div
            class="bg-white video-container rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 relative"
            style="height: 220px; min-height: 220px"
          >
            <!-- 封面图片（未播放时显示） -->
            <div
              v-if="playingIndex !== index"
              class="absolute inset-0 w-full h-full bg-cover bg-center flex items-center justify-center transition-opacity duration-300 hover:opacity-90"
              :style="{ backgroundImage: 'url(' + coverImage + ')' }"
            >
              <div
                class="youtube-play-button cursor-pointer"
                @click="playVideo(index)"
              >
                <div class="youtube-play-icon"></div>
              </div>
            </div>
            <!-- YouTube iframe（播放时显示） -->
            <iframe
              v-if="playingIndex === index"
              :src="video.url"
              title="Video "
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              class="w-full h-full hover:scale-105 transition-transform duration-200"
            ></iframe>
          </div>
          <div class="mt-4">
            <h3 class="text-lg font-semibold text-gray-500 text-center">
              {{ video.title }}
            </h3>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Video',
  components: {},
  data() {
    return {
      playingIndex: -1,
      coverImage: require('@/assets/web_pg_vo.jpg'),
      videos: [
        {
          url: 'https://www.youtube.com/embed/hSJxwrb8fUU?autoplay=1',
          title: 'DEERGIFTS CNC ENGRAVING',
          description: 'An overview of our latest product line and features.'
        },
        {
          url: 'https://www.youtube.com/embed/ZY6d69k8mNg?autoplay=1',
          title: 'DEERGIFTS MOLD MAKING',
          description: 'See how our products are made with precision and care.'
        },
        {
          url: 'https://www.youtube.com/embed/ijV0RHmeEX0?autoplay=1',
          title: 'DEERGIFTS MOLD POLISHING',
          description:
            'Hear from our satisfied customers about their experience.'
        },
        {
          url: 'https://www.youtube.com/embed/pfj4ZPxSUWk?autoplay=1',
          title: 'DEERGIFTS DIE CASTING',
          description: 'Meet the dedicated team behind our products.'
        },
        {
          url: 'https://www.youtube.com/embed/MszwcZTPHIk?autoplay=1',
          title: 'DEERGIFTS PRODUCT POLISHING',
          description:
            'Learn how to use our products effectively with this guide.'
        },
        {
          url: 'https://www.youtube.com/embed/TNwWIe3RUu0?autoplay=1',
          title: 'DEERGIFTS COLORING',
          description:
            'Our rigorous quality control process ensures excellence.'
        },
        {
          url: 'https://www.youtube.com/embed/sm3X_XiCXJo?autoplay=1',
          title: 'DEERGIFTS QC',
          description:
            'Discover our exciting new product collection for this season.'
        },
        {
          url: 'https://www.youtube.com/embed/9Yua78LNjjM?autoplay=1',
          title: 'DEERGIFTS PACKING',
          description:
            'Take a look behind the scenes at our company operations.'
        }
      ]
    }
  },
  methods: {
    playVideo(index) {
      this.playingIndex = index
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.youtube-play-button {
  width: 68px;
  height: 48px;
  background-color: #ff0033;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  opacity: 0;
}
.youtube-play-button:hover {
  background-color: #cc0000;
  transform: scale(1.05);
}
.youtube-play-icon {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 16px solid white;
  margin-left: 4px;
}
.video-container:hover .youtube-play-button {
  opacity: 1;
  transform: scale(1);
}
</style>



// WEBPACK FOOTER //
// src/page/index/videoSection.vue